/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  UncontrolledAlert
} from "reactstrap";
import ScrollableAnchor from 'react-scrollable-anchor';

// core components
import Navbar from "components/Navbars/Navbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

// load svgs
import GradHat from "../assets/img/icons/grad_hat.svg";
import Teaching from "../assets/img/icons/teaching.svg";

// image carousel
import { UncontrolledCarousel } from "reactstrap";

const randolf_pitch_items = [
  {
    src: require("../assets/img/photos/atmos_randolf_pitch.jpg"),
    altText: '',
    caption: '',
    header: ''
  },
  {
    src: require("../assets/img/photos/atmos_randolf_mckinney.jpg"),
    altText: '',
    caption: '',
    header: ''
  }
];

// contact form
class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {
        name: "",
        email: "",
        msg_content: ""
      },
      isSubmitting: false,
      isError: false
    };
  }
  submitForm = async e => {
      e.preventDefault();
      console.log(this.state);
      this.setState({ isSubmitting: true });

      var details = this.state.values;
      var formBody = "";
      var i = 0;
      for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        if (i === 0) {
          formBody += encodedKey + "=" + encodedValue;
        }
        else {
          formBody += "&&" + encodedKey + "=" + encodedValue;
        }
        i = i + 1;

      }
      console.log(formBody);


      const res = await fetch("https://script.google.com/macros/s/AKfycbxZ1A6R2ffQ0oo7EyG-WvMOfST9it_NdKYJMr766BOEqXMGrjge/exec", {
        method: "POST",
        body: formBody,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      });
      this.setState({ isSubmitting: false });
      const data = await res.json();
      !data.hasOwnProperty("error")
        ? this.setState({ message: data.success })
        : this.setState({ message: data.error, isError: true });

      setTimeout(
        () =>
          this.setState({
            isError: false,
            isSuccess: true,
            message: "",
            values: { name: "", email: "", msg_content: "" }
          }),
        1600
      );
    };

    handleInputChange = e =>
      this.setState({
        values: { ...this.state.values, [e.target.name]: e.target.value }
      });

    render() {
      return (
        <div>
        <div className={`message ${this.state.isError && "error"}`}>
          {this.state.isSubmitting ?
                <UncontrolledAlert color="info" fade={true} id="contactFormSuccess">
                    <span className="alert-inner--icon">
                      <i className="fas fa-envelope" />
                    </span>{" "}
                    <span className="alert-inner--text">
                      <strong>Loading!</strong> Your message is being processed.
                    </span>
                </UncontrolledAlert> : this.state.message}
          {this.state.isSuccess ?
                  <UncontrolledAlert color="success" fade={true} id="contactFormSuccess">
                      <span className="alert-inner--icon">
                        <i className="ni ni-like-2" />
                      </span>{" "}
                      <span className="alert-inner--text">
                        <strong>Success!</strong> Message was sent!
                      </span>
                  </UncontrolledAlert> : this.state.message}
          {this.state.isError ?
                  <UncontrolledAlert color="danger" fade={true} id="contactFormError">
                      <span className="alert-inner--icon">
                        <i className="fas fa-exclamation-circle" />
                      </span>{" "}
                      <span className="alert-inner--text">
                        <strong>Error!</strong> Something went wrong while sending your message. Try again in a couple minutes.
                      </span>
                  </UncontrolledAlert> : this.state.message}
        </div>
          <form onSubmit={this.submitForm}>
            <FormGroup
              className={classnames("mt-5", {
                focused: this.state.nameFocused
              })}
            >
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-user" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Your name"
                  type="text"
                  name="name"
                  id="name"
                  value={this.state.values.name}
                  onChange={this.handleInputChange}
                  title="Name"
                  required
                  onFocus={e => this.setState({ nameFocused: true })}
                  onBlur={e => this.setState({ nameFocused: false })}
                />
              </InputGroup>
            </FormGroup>

            <FormGroup
              className={classnames({
                focused: this.state.emailFocused
              })}
            >
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="ni ni-email-83" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  placeholder="Email address"
                  type="email"
                  name="email"
                  id="email"
                  value={this.state.values.email}
                  onChange={this.handleInputChange}
                  title="Email"
                  required
                  onFocus={e => this.setState({ emailFocused: true })}
                  onBlur={e => this.setState({ emailFocused: false })}
                />
              </InputGroup>
            </FormGroup>


              <FormGroup className="mb-4">
                <Input
                  className="form-control-alternative"
                  cols="80"
                  name="msg_content"
                  id="msg_content"
                  value={this.state.values.msg_content}
                  onChange={this.handleInputChange}
                  title="msg_content"
                  required
                  placeholder="Type a message..."
                  rows="4"
                  type="textarea"
                />
              </FormGroup>

              <Button
                block
                className="btn-round"
                color="default"
                size="lg"
                type="submit"
              >
                Send Message
              </Button>
          </form>
          <br></br>
        </div>
      );
    }
  }

// index page sections

class Landing extends React.Component {
  state = {};
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  render() {
    return (
      <>
        <ScrollableAnchor id={"topSection"}><Navbar /></ScrollableAnchor>
        <main ref="main">
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg bg-gradient-indigo pb-300">
              <div className="shape shape-style-1 shape-default">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
              <br></br>
                <Container className="py-lg-md d-flex">
                  <div className="col px-0">
                    <Row>
                      <Col lg="6">
                        <h1 className="display-2 text-white">
                          Welcome to the Future of Mentorship
                        </h1>
                        <br></br>
                        <h4 className="display-4 text-white">
                          <span>Students need a <i>reliable</i> and <i>accessible</i> support system now more than ever.
                            <br></br><br></br>Learn how to increase student retention and engagement with <b>Atmos.</b>
                          </span>
                        </h4>
                        <br></br>
                        <div className="btn-wrapper">
                          <Button
                            className="btn-icon mb-3 mb-sm-0"
                            color="info"
                            href="#valueaddSection"
                          >
                            <span className="btn-inner--icon mr-1">
                              <i className="ni ni-satisfied" />
                            </span>
                            <span className="btn-inner--text">How Atmos Helps Me</span>
                          </Button>
                          <br></br>
                          <br></br>
                        </div>
                      </Col>
                      <Col>
                      </Col>
                      <Col lg="6" className="mr--100">
                      <center>
                      <img
                        alt="..."
                        className="img-fluid floating"
                        src={process.env.PUBLIC_URL + "/screenshot_iphone_wrapping.png"}
                        width="60%"
                      />
                      </center>
                      </Col>
                    </Row>
                  </div>
                </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
              <br></br>
              <br></br>
              <br></br>
              <ScrollableAnchor id={'valueaddSection'}><br></br></ScrollableAnchor>
              <Container>
                <Row className="justify-content-center">
                    <Col lg="12">
                      <center>
                        <h4 className="display-4 text-white">
                          Meet Your Campus's Competitive Edge
                        </h4>
                      </center>
                      <center>
                        <h5 className="display-5 text-white">
                          Students <b>prefer</b> career advisors and mentors over any other career resource
                          <sup>
                            <a 
                            href="https://s3.amazonaws.com/ecommerce-prod.mheducation.com/unitas/corporate/promotions/2018-future-workforce-survey-analysis.pdf" 
                            target="_blank"
                            rel="noopener noreferrer">
                            1
                            </a>
                          </sup>. 
                          Leverage that to <i>Wow!</i> your prospective and current students,
                          minimize costs, and maximize value with Atmos.
                        </h5>
                      </center>
                      <br></br>
                    </Col>
                </Row>
            </Container>
            </section>
            {/* 1st Hero Variation */}
          </div>
            <section className="section section-lg pt-lg-0 mt--300">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                            <i className="ni ni-hat-3" />
                          </div>
                          <h6 className="text-primary text-uppercase">
                            Intuitive For Students
                          </h6>
                          <p className="description mt-3">
                          Atmos keeps students feeling valued and heard. Students can describe the 
                          challenge, goal, or question they have in their own words. Mentorship is always 
                          available from anywhere.
                          </p>
                          <div>
                            <Badge color="primary" pill className="mr-1">
                              authentic
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              flexible
                            </Badge>
                            <Badge color="primary" pill className="mr-1">
                              intuitive
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="primary"
                            href="#studentwalkthruSection"
                          >
                            Learn more
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                            <i className="fas fa-school" />
                          </div>
                          <h6 className="text-success text-uppercase">
                            Insightful for Schools
                          </h6>
                          <p className="description mt-3">
                          You want to know how your resources are affecting your students' success.
                          Atmos helps you replicate your campus's strengths and minimize its weaknesses 
                          by pinpointing core reasons.
                          </p>
                          <div>
                            <Badge color="success" pill className="mr-1">
                              retain
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              campus pulse
                            </Badge>
                            <Badge color="success" pill className="mr-1">
                              engage
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="success"
                            href="#universitywalkthruSection"
                          >
                            Learn more
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                            <i className="fas fa-chalkboard-teacher" />
                          </div>
                          <h6 className="text-warning text-uppercase">
                            Flexible for Mentors
                          </h6>
                          <p className="description mt-3">
                             <i>How busy will I be? Can I just focus on one or two mentees? </i>
                             Quality mentors are a scarce resource. Keep quality mentors engaged by
                            answering those questions and more with Atmos.
                          </p>
                          <div>
                            <Badge color="warning" pill className="mr-1">
                              flexibility
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              control
                            </Badge>
                            <Badge color="warning" pill className="mr-1">
                              security
                            </Badge>
                          </div>
                          <Button
                            className="mt-4"
                            color="warning"
                            href="#mentorwalkthruSection"
                          >
                            Learn more
                          </Button>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew zindex-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="fill-white"
                    points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </Container>
          </section>
          <ScrollableAnchor id={'studentwalkthruSection'}><span></span></ScrollableAnchor>
          <section className="section section-lg mt--100">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
              <Col lg="8">
                <h2 className="display-3">How It Works</h2>
                <p className="lead text-muted">
                Atmos is a text based, mentor management, and retention platform, that accurately connects
                students to mentors in a more personalized and efficient way
                than ever before.
                </p>
              </Col>
            </Row>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={process.env.PUBLIC_URL + "/screenshot_black_iphone_convo1.png"}
                    width="60%"
                  />
                </Col>
                <Col className="order-md-1" md="6">
                    <div className="pr-md-5">
                      <div className="icon icon-lg icon-shape icon-shape-info shadow rounded-circle mb-5">
                        <i className="fas fa-bullseye" />
                      </div>
                      <h3>Describe</h3>
                      <p>
                        Start by sending Atmos a text. Students can describe the challenge, goal, or question they have in their own words.
                        That means students don't need to fit their futures in a predefined box.
                      </p>
                      <ul className="list-unstyled mt-5">
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="info"
                              >
                                <i className="fas fa-sms" />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0">
                                Communicate through texting
                              </h6>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="info"
                              >
                                <i className="fas fa-user-shield" />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0">No login: One-time verification of school email</h6>
                            </div>
                          </div>
                        </li>
                        <li className="py-2">
                          <div className="d-flex align-items-center">
                            <div>
                              <Badge
                                className="badge-circle mr-3"
                                color="info"
                              >
                                <i className="ni ni-satisfied" />
                              </Badge>
                            </div>
                            <div>
                              <h6 className="mb-0">
                                Available 24/7
                              </h6>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-1" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={process.env.PUBLIC_URL + "/screenshot_black_iphone_convo2.png"}
                    width="60%"
                  />
                </Col>
                <Col className="order-md-2" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="fas fa-project-diagram" />
                    </div>
                    <h3>Connect</h3>
                    <p>
                      Next, students choose a recommended mentor that matches the situation the best and a time for a
                      video chat meeting. All video chats occur within the Atmos platform ensuring a student never
                      leaves the platform for a seamless and secure experience.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="fas fa-draw-polygon" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Flexible scheduling
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="fas fa-grip-lines" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Seamless and intuitive usage</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="warning"
                            >
                              <i className="fas fa-shield-alt" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Secure video meetings
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={process.env.PUBLIC_URL + "/screenshot_black_iphone_convo3.png"}
                    width="60%"
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                      <i className="fas fa-shapes" />
                    </div>
                    <h3>Prepare</h3>
                    <p>
                    Before the meeting, students can prepare themselves, ensuring that they are confident and have a productive meeting.
                    This is a great touch-point for universities to re-instill values, principles, and skills into their students.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-brain" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Get students critically thinking
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-dumbbell" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Reinforce concepts</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-chart-line" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Ensure more productive meetings
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg bg-secondary">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-1" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={process.env.PUBLIC_URL + "/screenshot_black_iphone_convo4.png"}
                    width="60%"
                  />
                </Col>
                <Col className="order-md-2" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-success shadow rounded-circle mb-5">
                      <i className="fas fa-hands-helping" />
                    </div>
                    <h3>Retain</h3>
                    <p>
                    Based on user feedback and Natural Language Processing, Atmos improves its recommendation
                    system for more helpful student/mentor interactions. Over time, Atmos refines its
                    insights such as what students find important, what they are lacking, and how they are feeling.

                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="fas fa-laugh" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Touch-points for candid and authentic feedback
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="fas fa-heart" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Analyze the "pulse" of the campus</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="fas fa-code" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Forever learning and improving
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <br></br>
                    <Button
                      className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                      color="default"
                      href="#contactSection"
                    >
                      <span className="btn-inner--icon mr-1">
                        <i className="fa fa-desktop" />
                      </span>
                      <span className="btn-inner--text">
                        Request My Demo
                      </span>
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg">
            <Container>
            <Row className="justify-content-center text-center">
              <Col lg="8">
              <ScrollableAnchor id={'universitywalkthruSection'}>
                <p>
                  <img src={Teaching} alt="Teaching" width="50%"/>
                </p>
              </ScrollableAnchor>
                <h2 className="display-3">How Universities Benefit</h2>
                <p className="lead text-muted">
                Atmos helps your students realize their education's value and address
                obstacles that prevent them from reaching their goals and staying enrolled.
                </p>
              </Col>
            </Row>
            <br></br>
            <p>
              <img
                alt="..."
                className="img-fluid"
                src={process.env.PUBLIC_URL + "/mentor_management.png"}
                width="100%"
              />
            </p>
            <Row className="justify-content-center text-center mb-lg">
              <Col lg="6">
                <Card className="card-lift--hover shadow border-0">
                  <CardBody className="">
                    <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                      <i className="fas fa-chart-pie" />
                    </div>
                    <h4 className="text-primary">
                      Tags & Feedback
                    </h4>
                    <p>
                    Tags and student feedback enable you to replicate your campus's strengths and minimize 
                    its weaknesses. Atmos can help you discover gaps in mentor expertise, what
                    fields are in demand, and what areas mentors are doing well in and could improve in.
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6">
                <Card className="card-lift--hover shadow border-0">
                  <CardBody className="">
                    <div className="icon icon-shape icon-shape-primary rounded-circle mb-4">
                      <i className="fas fa-heart" />
                    </div>
                    <h4 className="text-primary">
                      Campus Pulse
                    </h4>
                    <p>
                      Atmos' dashboard has intelligent metrics that inform administrators on student 
                      communication skills, campus sentiment, what's important to students, what's 
                      worrying students, the types of goals students are setting, and much more.
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <ScrollableAnchor id={'mentorwalkthruSection'}><span></span></ScrollableAnchor>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={process.env.PUBLIC_URL + "/screenshot_black_iphone_convo2.png"}
                    width="60%"
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <div className="icon icon-lg icon-shape icon-shape-primary shadow rounded-circle mb-5">
                      <i className="fas fa-chalkboard-teacher" />
                    </div>
                    <h3>Mentors are Optimized</h3>
                    <p>
                      Mentors are tired of back-and-forth messaging for scheduling. That ends now.
                    </p>
                    <p>
                      Atmos doesn't burden your mentors with irrelevant notifications either. 
                      Intelligent mentor recommendation means only pertinent requests are emailed to them.
                    </p>
                    <p>
                      If a mentor feels overwhelmed and wants to focus on a couple mentees, they
                      can easily set their statuses as "focused" so that their current mentees only can ask for help.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-calendar-alt" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Flexible & efficient scheduling
                            </h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-brain" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">Intelligent mentor recommendation</h6>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="primary"
                            >
                              <i className="fas fa-user-check" />
                            </Badge>
                          </div>
                          <div>
                            <h6 className="mb-0">
                              Control availability
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              
            </Container>
          </section>
          <section className="section pb-100">
              <Container>
                <Row className="justify-content-center text-center">
                  <Col lg="8">
                    <h2 className="display-3">What's the end result?</h2>
                    <p>
                      <img src={GradHat} alt="Grad Hat" width="50%"/>
                    </p>
                    <p className="lead text-muted">
                      Many more engaged and successful students who graduate!
                    </p>
                    <br></br>
                    <p>
                      <Button
                        className="btn-primary btn-icon"
                        color="primary"
                        href="#contactSection"
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fa fa-desktop" />
                        </span>
                        <span className="btn-inner--text">
                          Request My Demo
                        </span>
                      </Button>
                    </p>
                  </Col>
                </Row>
              </Container>
            </section>
          <section className="section pb-0 bg-gradient-warning">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-lg-1" lg="12">
                  <div className="d-flex px-3">
                    <div>
                      <div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                        <i className="far fa-newspaper text-primary" />
                      </div>
                    </div>
                    <div className="pl-4">
                      <ScrollableAnchor id={'reviewsSection'}><h4 className="display-3 text-white">Recent Buzz</h4></ScrollableAnchor>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="row-grid align-items-center">
                      <Col className="order-lg-2" lg="6">
                        <Card className="shadow shadow-lg--hover mt-5">
                            <CardBody>
                              <div className="d-flex px-3">
                                <div>
                                  <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                    <i className="fas fa-trophy" />
                                  </div>
                                </div>
                                <div className="pl-4">
                                  <center>
                                    <img 
                                    src={process.env.PUBLIC_URL + "/bus_plan_comp_insta.jpg"} 
                                    alt="PSB Winner" 
                                    width="100%"/>
                                  </center>
                                  <br></br>
                                  <p>
                                    BlueSkyAI is a winner of the 2020 High Point University PSB Business Plan Competition.
                                  </p>
                                  <br></br>
                                  <br></br>
                                  <br></br>
                                  <br></br>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col className="order-lg-2" lg="6">
                        <Card className="shadow shadow-lg--hover mt-5">
                            <CardBody>
                              <div className="d-flex px-3">
                                <div>
                                  <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                                    <i className="fas fa-camera" />
                                  </div>
                                </div>
                                <div className="pl-4">
                                  <center>
                                  <UncontrolledCarousel items={randolf_pitch_items} />
                                  </center>
                                  <br></br>
                                  <p>
                                    Mark McKinney was able to pitch Atmos to Netflix Co-Founder, Marc Randolf,
                                    for company feedback and mentorship.
                                  </p>
                                  <br></br>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col className="order-lg-2" lg="6">
                          <Card className="shadow shadow-lg--hover mt-5">
                            <CardBody>
                              <div className="d-flex px-3">
                                <div>
                                  <div className="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                    <i className="fas fa-quote-right" />
                                  </div>
                                </div>
                                <div className="pl-4">
                                  <h5 className="title text-warning">
                                    Build Connections
                                  </h5>
                                  <p>
                                    I think that's awesome. I could have used that for just <b>getting connected
                                    with the right professors</b>. For instance, I found out in December that there
                                    was a professor involved in cancer research and like if you had something
                                    like that it could help with connections to those types of things.
                                  </p>
                                  <span
                                    className="text-warning"
                                  >
                                  Kiara W.
                                  <br></br>
                                  Senior, University of Tampa
                                  </span>
                                  <br></br>
                                  <br></br>
                                  <br></br>
                                  <br></br>

                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col className="order-lg-2" lg="6">
                          <Card className="shadow shadow-lg--hover mt-5">
                            <CardBody>
                              <div className="d-flex px-3">
                                <div>
                                  <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                                    <i className="fas fa-camera" />
                                  </div>
                                </div>
                                <div className="pl-4">
                                <center>
                                      <img 
                                      src={process.env.PUBLIC_URL + "/beta_test_presentation.jpg"} 
                                      alt="Beta Test Presentation" 
                                      width="100%"/>
                                    </center>
                                    <br></br>
                                    <p>
                                      Mark McKinney presenting the Atmos Beta to the Hight Point University Freshman Class.
                                    </p>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col className="order-lg-2" lg="12">
                          <Card className="shadow shadow-lg--hover mt-5">
                            <CardBody>
                              <div className="d-flex px-3">
                                <div>
                                  <div className="icon icon-shape bg-gradient-success rounded-circle text-white">
                                    <i className="fas fa-quote-right" />
                                  </div>
                                </div>
                                <div className="pl-4">
                                  <h5 className="title text-success">
                                    Empower Students
                                  </h5>
                                  <p>
                                  The Atmos chatbot would serve as a great
                                  tool for <b>connecting students to resources and mentors that can empower students</b>.
                                  Our retention project operates through peer counseling sessions and mentorship
                                  matches between students and alumni and this software would greatly assist
                                  us...by automating a lot of manual work we have to put in.
                                  </p>
                                  <p>
                                  I can see a lot of potential for the program and would hope to see spaces like
                                  mine and others apply this software in order to improve retention and student
                                  engagement in higher education.
                                </p>
                                  <span
                                    className="text-success"
                                  >
                                  Ian T.
                                  <br></br>
                                  Retention Coordinator & Academic Supports Program, UCLA
                                  </span>
                                </div>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <br></br>
                      <br></br>
            </Container>
          </section>
          <section className="section section-lg">
            <Container>
              <Row className="justify-content-center text-center mb-lg">
                <Col lg="8">
                  <ScrollableAnchor id={'teamSection'}><h2 className="display-3">The BlueSkyAI Team</h2></ScrollableAnchor>
                  <p className="lead text-muted">
                    <b>blue-sky thinking</b> [<i>noun</i>]: creative ideas that are not limited by current thinking or beliefs.
                  </p>
                </Col>
              </Row>
              <Row>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={process.env.PUBLIC_URL + "/mark_mckinney.jpg"}
                      style={{ width: "150px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Mark McKinney</span>
                        <small className="h6 text-muted">CEO & Founder</small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="warning"
                          href="https://twitter.com/MarkDMcKinney"
                          target="_blank"

                        >
                          <i className="fab fa-twitter" />
                        </Button>
                        <Button
                          className="btn-icon-only rounded-circle ml-1"
                          color="warning"
                          href="https://www.linkedin.com/in/mark-d-mckinney/"
                          target="_blank"

                        >
                          <i className="fab fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={process.env.PUBLIC_URL + "/austin_baker.jpg"}
                      style={{ width: "150px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Austin Baker</span>
                        <small className="h6 text-muted">
                          VP & Co-Founder
                        </small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="primary"
                          href="https://www.linkedin.com/in/bakerusa/"
                          target="_blank"

                        >
                          <i className="fab fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col className="mb-5 mb-lg-0" lg="4" md="6">
                  <div className="px-4">
                    <img
                      alt="..."
                      className="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                      src={process.env.PUBLIC_URL + "/billy_pham.jpg"}
                      style={{ width: "150px" }}
                    />
                    <div className="pt-4 text-center">
                      <h5 className="title">
                        <span className="d-block mb-1">Billy Pham</span>
                        <small className="h6 text-muted">Lead Engineer</small>
                      </h5>
                      <div className="mt-3">
                        <Button
                          className="btn-icon-only rounded-circle"
                          color="info"
                          href="https://www.linkedin.com/in/billy-pham-70bb7735/"
                          target="_blank"

                        >
                          <i className="fab fa-linkedin" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <ScrollableAnchor id={'contactSection'}><span></span></ScrollableAnchor>
          <section className="section section-lg bg-gradient-indigo">
            <Container>
              <Card>
                <div className="p-5">
                  <Row className="align-items-center">
                    <Col lg="12">
                    <h3 className="text-black">
                        Drop us a line!
                      </h3>
                      <p className="lead text-black mt-3">
                        Interested in a demo? Have questions? We want to hear from you!
                      </p>
                      <ContactForm />
                    </Col>
                  </Row>
                </div>
              </Card>
            </Container>
          </section>
        </main>
        <CardsFooter />
      </>
    );
  }
}

export default Landing;
